import PropTypes from 'prop-types';
import React from 'react';
import phoenixRender, {SIZES, PARTS} from './phoenixRender';

const HEIGHT = 24;
const WIDTH = 48;

const ChartMicro = ({chartRender, isLoaded}) =>
  isLoaded && chartRender && chartRender.image ? (
    <img
      style={{maxHeight: HEIGHT}}
      src={`data:image/png;base64,${chartRender.image.data}`}
    />
  ) : null;

ChartMicro.propTypes = {
  card: PropTypes.object.isRequired,
};

export default phoenixRender(() => ({
  width: WIDTH,
  height: HEIGHT,
  size: `${SIZES.MEDIUM}:${WIDTH}:${HEIGHT}`,
  parts: [PARTS.IMAGE],
}))(ChartMicro);
